export default __webpack_public_path__ + "static/media/property_77.14da9488.png";